import { Lightning } from '@lightningjs/sdk';
import { RecordingFolderDataSource } from '../../../Business/recording/RecordingFolderDataSource';
import { Button } from '../../../components/shared/Button';
import { RecordingTranslationKeys } from '../../../api/models/TranslationKeys';
import { AdultType } from '../../../api/models/Shared.types';
import { _constants } from '../../../components/MiniDetail';
import { CmsConstants } from '../../../Business/cms/CmsConstants';

const Constants = {
  button: {
    margin: {
      left: CmsConstants.Ribbon.pageContentOffset,
      top: 56,
    },
    height: 60,
    width: 200,
  },
};
export class RecordingFolderPage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      clipping: true,
      w: w => w,
      h: h => h,
      Container: {
        w: w => w,
        DeleteAll: {
          x: Constants.button.margin.left,
          y: Constants.button.margin.top,
          type: Button,
          buttonMode: 'primary',
          signals: {
            onActivate: '_handleDelete',
          },
        },
        Content: {
          flex: { direction: 'column' },
          w: w => w,
          y: Constants.button.margin.top + Constants.button.height + 10,
        },
      },
    };
  }

  _init() {
    /**
     * @type {Backend}
     */

    const backend = this.params.backend;
    const folderInfo = this.params.folderInfo;
    this.tag('DeleteAll').label = backend.translations.forKey(RecordingTranslationKeys.recordings_delete_all);
    Promise.all([
      backend.cachedChannelApi.channels(backend),
      backend.cachedRecordingsApi.recordingsFolderForType(
        backend,
        folderInfo.pageType,
        AdultType.False,
        folderInfo.seriesId,
        folderInfo.channelId
      ),
    ]).then(data => {
      this.ds = new RecordingFolderDataSource(backend, this, data[1], data[0], folderInfo);
      const grids = this.ds.getRecordingContent();
      if (!grids) {
        return;
      }
      const content = this.tag('Content');
      Promise.all(grids).then(sources => {
        sources.forEach(grid => {
          content.childList.a({
            flexItem: { marginBottom: 20 },
            signals: { centerVertical: '_centerVertical' },
            w: this.finalW,
            x: CmsConstants.Ribbon.pageContentOffset,
            ...grid.componentDescription(),
          });
        });
        this.focusIndex = content.childList.length > 0 ? 0 : -1;
        this._refocus();
      });
    });
  }

  _getFocused() {
    if (this.focusIndex !== -1) {
      return this.tag('Content').children[this.focusIndex];
    } else {
      return this.tag('DeleteAll');
    }
  }

  _centerVertical(centerY) {
    // Workaround for modals
    // Showing/hiding a modal will cause a refocus event, at which point this.finalH === 0
    // Prevent recentering in that case
    if (this.finalH === 0) return;

    let target = this.finalH / 2;

    if (this.tag('Content').children[this.focusIndex].data.cmsProperties) {
      if (!this.tag('Content').children[this.focusIndex].data.cmsProperties.includes('HIDE_MINI_DETAIL')) {
        target = (this.finalH - _constants.miniDetailHeight) / 2;
      }
    }

    const result = Math.min(
      0, //-this.tag('Content').finalH + this.tag('Content').finalH - constants.marginBottom,
      target - centerY
    );
    // console.log('centerVertical', centerY, target, result, this.tag('Content').finalH);

    this.tag('Container').setSmooth('y', result);
  }

  _handleDown() {
    if (this.focusIndex < this.tag('Content').children.length - 1) {
      this.focusIndex++;
    }
  }

  _handleUp() {
    if (this.focusIndex >= 0) {
      this.focusIndex--;
    }
  }

  _handleDelete() {
    this.ds.handleDelete();
  }

  _handleBack() {
    this.ds.returnToPrevious();
  }

  $deleteSeries() {
    this.ds.forceDelete();
  }
}
